import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	forgeSectionTitle: {
		id: 'navigation-apps-sidebar-forge.personal-settings-section.forge-section-title',
		defaultMessage: 'Apps',
		description: 'Navigation section title for forge apps items',
	},
});
